import buffer from '@turf/buffer';
import difference from '@turf/difference';
import * as TurfHelpers from '@turf/helpers';

/**
 * Function that cuts a {@link Polygon} with a {@link Linestring}
 * @param {Feature<(Polygon)>} poly - single Polygon Feature
 * @param {Feature<(Polyline)>} line - single Polyline Feature
 * @return {FeatureCollection<(Polygon)>}
 * @author Abel Vázquez
 * @version 1.0.0
 */
export default function (poly, line) {
  //var poly1 = turf.polygon([poly.geometry.coordinates])

  const _axe = buffer(line, 1, { units: 'meters' }), // turf-buffer issue #23
    _body = difference(poly, _axe),
    pieces = [];

  _body.geometry.coordinates.forEach((a) => {
    const coords = _body.geometry.type === 'Polygon' ? [a] : a;
    pieces.push(TurfHelpers.polygon(coords));
  });

  pieces.forEach((a) => {
    a.properties = { ...poly.properties };
  });

  return TurfHelpers.featureCollection(pieces);
}
